/* ------------------------------------------------------------------------------
 *
 *  # Card Actions Module
 *
 *  Card functionality (reload, collapse, remove, fullscreen)
 *
 * ---------------------------------------------------------------------------- */

// Reload card (uses BlockUI extension)
export function cardActionReload() {
    // Elements
    const buttonClass = '[data-card-action=reload]',
        containerClass = 'card',
        overlayClass = 'card-overlay',
        spinnerClass = 'ph-circle-notch',
        overlayAnimationClass = 'card-overlay-fadeout';

    // Configure
    document.querySelectorAll(buttonClass).forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();

            // Elements
            const parentContainer = button.closest(`.${containerClass}`),
                overlayElement = document.createElement('div'),
                overlayElementIcon = document.createElement('i');

            // Append overlay with icon
            overlayElement.classList.add(overlayClass);
            parentContainer.appendChild(overlayElement);
            overlayElementIcon.classList.add(spinnerClass, 'spinner', 'text-body');
            overlayElement.appendChild(overlayElementIcon);

            // Remove overlay after 2.5s, for demo only
            setTimeout(function () {
                overlayElement.classList.add(overlayAnimationClass);
                ['animationend', 'animationcancel'].forEach(function (e) {
                    overlayElement.addEventListener(e, function () {
                        overlayElement.remove();
                    });
                });
            }, 2500);
        });
    });
}

// Collapse card
export function cardActionCollapse() {
    // Elements
    const buttonClass = '[data-card-action=collapse]',
        cardCollapsedClass = 'card-collapsed';

    // Setup
    document.querySelectorAll(buttonClass).forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();

            const parentContainer = button.closest('.card'),
                collapsibleContainer = parentContainer.querySelectorAll(':scope > .collapse');

            if (parentContainer.classList.contains(cardCollapsedClass)) {
                parentContainer.classList.remove(cardCollapsedClass);
                collapsibleContainer.forEach(function (toggle) {
                    new bootstrap.Collapse(toggle, {
                        show: true
                    });
                });
            }
            else {
                parentContainer.classList.add(cardCollapsedClass);
                collapsibleContainer.forEach(function (toggle) {
                    new bootstrap.Collapse(toggle, {
                        hide: true
                    });
                });
            }
        });
    });
}

// Remove card
export function cardActionRemove() {
    // Elements
    const buttonClass = '[data-card-action=remove]',
        containerClass = 'card'

    // Config
    document.querySelectorAll(buttonClass).forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            button.closest(`.${containerClass}`).remove();
        });
    });
}

// Card fullscreen mode
export function cardActionFullscreen() {
    // Elements
    const buttonAttribute = '[data-card-action=fullscreen]',
        buttonClass = 'text-body',
        buttonContainerClass = 'd-inline-flex',
        cardFullscreenClass = 'card-fullscreen',
        collapsedClass = 'collapsed-in-fullscreen',
        scrollableContainerClass = 'content-inner',
        fullscreenAttr = 'data-fullscreen';

    // Configure
    document.querySelectorAll(buttonAttribute).forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();

            // Get closest card container
            const cardFullscreen = button.closest('.card');

            // Toggle required classes
            cardFullscreen.classList.toggle(cardFullscreenClass);

            // Toggle classes depending on state
            if (!cardFullscreen.classList.contains(cardFullscreenClass)) {
                button.removeAttribute(fullscreenAttr);
                cardFullscreen.querySelectorAll(`:scope > .${collapsedClass}`).forEach(function (collapsedElement) {
                    collapsedElement.classList.remove('show');
                });
                document.querySelector(`.${scrollableContainerClass}`).classList.remove('overflow-hidden');
                button.closest(`.${buttonContainerClass}`).querySelectorAll(`:scope > .${buttonClass}:not(${buttonAttribute})`).forEach(function (actions) {
                    actions.classList.remove('d-none');
                });
            }
            else {
                button.setAttribute(fullscreenAttr, 'active');
                cardFullscreen.removeAttribute('style');
                cardFullscreen.querySelectorAll(`:scope > .collapse:not(.show)`).forEach(function (collapsedElement) {
                    collapsedElement.classList.add('show', `.${collapsedClass}`);
                });
                document.querySelector(`.${scrollableContainerClass}`).classList.add('overflow-hidden');
                button.closest(`.${buttonContainerClass}`).querySelectorAll(`:scope > .${buttonClass}:not(${buttonAttribute})`).forEach(function (actions) {
                    actions.classList.add('d-none');
                });
            }
        });
    });
}
